import { Component } from '@angular/core';

@Component({
  selector: 'newauthfaq',
  imports: [],
  templateUrl: './newauthfaq.component.html',
  styleUrl: './newauthfaq.component.css'
})
export class NewauthfaqComponent {

}
